import type { VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/сn';
import { sfMarkStyles } from './styles';

interface SfMarkProps extends VariantProps<typeof sfMarkStyles> {
  className?: string;
}

export const SfMark = ({ size = 'large', color = 'white', className }: SfMarkProps) => (
  <span className={cn(sfMarkStyles({ size, color }), className)} aria-hidden="true">
    {size === 'small' ? (
      <>
        <span>S</span>
        <span className="-ml-[3px] translate-y-[5px]">F</span>
      </>
    ) : (
      <>
        <span className="absolute left-[3.16px] top-[0.16px]">S</span>
        <span className="absolute left-[12.16px] top-[7.16px]">F</span>
      </>
    )}
  </span>
);
